import { type FC } from 'react';
import { twMerge } from 'tailwind-merge';
import { ShareStreamSidebar } from './ShareStreamSidebar';
import { BookmarkButton } from './BookmarkButton';
import { type ShareAndBookmark } from '../StreamDashboard.types';

// Share strip and bookmark, between sm and md only.
export const ShareAndBookmarkRow: FC<ShareAndBookmark & { className?: string }> = ({
    canShare,
    onShare,
    showBookmark,
    favorite,
    isBookmarkDisabled,
    onToggleBookmark,
    className,
}) => {
    if (!canShare && !showBookmark) return null;

    return (
        <div className={twMerge('hidden gap-3.5 sm:flex md:hidden', className)}>
            {canShare && <ShareStreamSidebar onShare={onShare} variant="row" className="flex-1" />}

            {showBookmark && (
                <BookmarkButton
                    favorite={favorite}
                    disabled={isBookmarkDisabled}
                    onToggle={onToggleBookmark}
                    className="flex-1"
                />
            )}
        </div>
    );
};
